const flights = [
  {
    path: "/flight",
    name: "flightBooking",
    component: () => import('@/views/FlightBooking'), // Main parent component
    props: true,
    meta: { showHeader: true , mainPage : true },
  },
      {
        path: "",
        name: "Booking",
        component: () => import('@/components/FlightBooking/Booking'), // Parent of booking/payment
        props: true,
        meta: { showHeader: false }, // Hide header for children
        children: [
          {
            path: "booking", // Relative path for /flight/booking
            name: "FlightBooking",
            component: () => import('@/components/FlightBooking/FlightForm'),
            props: true,
          },
          {
            path: "payment", // Relative path for /flight/payment
            name: "FlightPayment",
            component: () => import('@/components/FlightBooking/FlightPayment'),
            props: true,
          },
        ],
      },
      {
        // flight/payment/confirmation/failure?ref=bd90ab
        // flight/booking/payment/mytmoney/thank-you?ref=bd90a9
        path: "booking/payment/:paymentMethod/:response",
        name: "flight-payment-confirmation",
        component: () => import('@/components/FlightBooking/FlightConfirmation'), 
        props: true,
      },
  
];

export default flights;
